import React from "react";
import { Link } from "@quintype/components";
import { string, object, bool } from "prop-types";

import "./newsHeadline.m.css";

const NewsHeadline = ({
  titleText = "",
  titleLink = "",
  subHeadlineText = "",
  cssStyleName,
  sectionData,
  showSectionTag,
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
  currentStoryTitleColor = "",
}) => {
  return (
    <h2 styleName={`title ${cssStyleName}`} className="headline-title" style={{ color: currentStoryTitleColor }}>
      {showSectionTag && sectionData.link === "/video" ? (
        <>
          <Link href={sectionData.link}>
            <span styleName="sub-title with-link">{sectionData.name}</span>
          </Link>
          <Link href={titleLink} styleName="title-link">
            {titleText}
          </Link>
        </>
      ) : (
        <Link
          href={titleLink}
          styleName="title-link"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label={datatrackinglabel}
        >
          {subHeadlineText && <span styleName="sub-title no-link">{subHeadlineText}</span>}

          {titleText}
        </Link>
      )}
    </h2>
  );
};

NewsHeadline.propTypes = {
  titleText: string,
  titleLink: string,
  subHeadlineText: string,
  cssStyleName: string,
  sectionData: object,
  showSectionTag: bool,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
  currentStoryTitleColor: string,
};

export default NewsHeadline;
